import { UserState } from './user/user.state';
import { OrganisationState } from './organisation/organisation.state';
import { ProjectState } from './project/project.state';
import { NotificationState } from './notification/notification.state';
import { ProjectDecisionState } from '@project/store/project-decisions/project-decisions.state';
import { SelectedProjectState } from '@project/store/selected-project/selected-project.state';
import { ProjectTeamState } from '@project/store/team/project-team.state';
import { ProjectImageAnalyticsState } from '@project/store/image-analytics/project-image-analytics.state';
import { ProjectDeliveryPlanState } from '@project/store/project-delivery-plan/project-delivery-plan.state';
import { ProjectFileDistributionState } from '@app/main/pages/project/store/project-file-distribution/project-file-distribution.state';

export const appState = [
  UserState,
  OrganisationState,
  ProjectState,
  NotificationState,
  ProjectDecisionState,
  SelectedProjectState,
  ProjectTeamState,
  ProjectImageAnalyticsState,
  ProjectDeliveryPlanState,
  ProjectFileDistributionState,
];
